import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faFileContract } from '@fortawesome/free-solid-svg-icons'

export default function Terms() {
  return (
    <div className="min-h-screen bg-white font-sans antialiased">
      <Navbar />
      <main className="pt-24 pb-16">
        <article className="max-w-3xl mx-auto px-4 sm:px-6 prose prose-slate">
          <a href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-blue-600 mb-6 no-underline">
            <FontAwesomeIcon icon={faArrowLeft} className="w-3.5 h-3.5" />
            Kembali ke Beranda
          </a>
          <div className="flex items-center gap-3 mb-2">
            <FontAwesomeIcon icon={faFileContract} className="w-6 h-6 text-blue-600" />
            <h1 className="text-3xl font-bold text-slate-900 m-0">Syarat &amp; Ketentuan</h1>
          </div>
          <p className="text-slate-500 text-sm">Terakhir diperbarui: Juni 2026</p>

          <h2>1. Penerimaan Syarat</h2>
          <p>
            Dengan mendaftar dan menggunakan WBS Pemprov Kalsel, Anda menyetujui syarat dan ketentuan
            berikut. Jika tidak setuju, harap tidak menggunakan layanan ini.
          </p>

          <h2>2. Penggunaan Layanan</h2>
          <ul>
            <li>Laporan harus disampaikan dengan itikad baik dan berdasarkan informasi yang Anda yakini benar.</li>
            <li>Dilarang menyampaikan laporan palsu, fitnah, atau yang tidak relevan dengan pelanggaran.</li>
            <li>Pengguna wajib menjaga kerahasiaan kode pelacakan dan kredensial akun masing-masing.</li>
          </ul>

          <h2>3. Laporan Anonim</h2>
          <p>
            Pelapor dapat memilih mode anonim. Identitas hanya dibuka jika pelapor memberikan persetujuan
            melalui mekanisme identitas dan PKS yang tersedia di sistem.
          </p>

          <h2>4. Tanggung Jawab Admin</h2>
          <p>
            Admin berwenang memproses, memverifikasi, dan menindaklanjuti laporan sesuai prosedur
            yang berlaku. Admin wajib menjaga kerahasiaan identitas dan isi laporan.
          </p>

          <h2>5. Ketersediaan Layanan</h2>
          <p>
            Pengelola berupaya menjaga ketersediaan sistem, namun tidak menjamin layanan bebas gangguan.
            Pemeliharaan dapat dilakukan sewaktu-waktu dengan pemberitahuan seperlunya.
          </p>

          <h2>6. Perubahan Ketentuan</h2>
          <p>
            Syarat dan ketentuan dapat diperbarui. Versi terbaru akan dipublikasikan di halaman ini.
            Penggunaan berkelanjutan setelah perubahan dianggap sebagai persetujuan.
          </p>
        </article>
      </main>
      <Footer />
    </div>
  )
}
